import { render } from "./EmailSent.vue?vue&type=template&id=6b4fb214&scoped=true"
import script from "./EmailSent.vue?vue&type=script&lang=js"
export * from "./EmailSent.vue?vue&type=script&lang=js"

import "./EmailSent.vue?vue&type=style&index=0&id=6b4fb214&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b4fb214"]])

export default __exports__